import React from "react";
import { PTO_STATUS } from "./_common";

const PtoButtonPanel = (props) => {
    /**
     * @type {{ 
     *  deniableCodes: Map<string, {typeCode: string, reasonCode: string}
     * }}
     */
    const { item, pto, typeCode, dateRange, deniableCodes, ...rest } = props;

    if (pto) {        
        if (pto.statusCode === PTO_STATUS.Cancelled ||
            pto.statusCode === PTO_STATUS.Processed ||
            pto.statusCode === PTO_STATUS.Denied) {
            return null;
        }

        if (pto.statusCode === PTO_STATUS.Approved && 
            (typeCode === "PTO" ||
            typeCode === "FTO" ||
            typeCode === "FTOSICK" ||
            typeCode === "SICK")) {
            return (
                <div className="pto-button-group">
                    <button className="pto-button" onClick={(evt) => raiseClick(evt, item, props.onCancel)}>Cancel</button>
                </div>
            );
        }
        
        const deniableKey = `${pto.code || ""}|${pto.reasonCode || ""}`.toUpperCase();

        if (pto.statusCode === PTO_STATUS.Requested) {
            if (deniableCodes.has(deniableKey)) {
                return (
                    <div className="pto-button-group">
                        <button className="pto-button primary" onClick={(evt) => raiseClick(evt, item, props.onApprove)}>Approve</button>
                        <button className="pto-button" onClick={(evt) => raiseClick(evt, item, props.onDeny)}>Decline</button>
                    </div>
                );
            } else {
                return (
                    <div className="pto-button-group">
                        <button className="pto-button primary" onClick={(evt) => raiseClick(evt, item, props.onApprove)}>Approve</button>
                        <button className="pto-button" onClick={(evt) => raiseClick(evt, item, props.onConsultHR)}>Consult HR</button>
                    </div>
                );
            }
        } else {
            return null;
        }

        // if (pto.statusCode === PTO_STATUS.Requested) {
        //     if (typeCode === "HOL" || typeCode === "SICK") {
        //         return (
        //             <div className="pto-button-group">
        //                 <button className="pto-button primary" onClick={(evt) => raiseClick(evt, item, props.onApprove)}>Approve</button>
        //                 <button className="pto-button" onClick={(evt) => raiseClick(evt, item, props.onConsultHR)}>Consult HR</button>
        //             </div>
        //         );
        //     }
        // }
    }

    return null;

    /**
     * 
     * @param {import("react").MouseEvent} evt 
     * @param {*} item 
     * @param {*} func 
     * @returns 
     */
    function raiseClick(evt, item, func) {
        evt.preventDefault();
        evt.stopPropagation();
        if (func) func(item);
        return false;
    }
};

export default PtoButtonPanel;